import { InteractiveNotification } from 'types/global'
import { action } from 'typesafe-actions'

export const PUSH_NOTIFICATION = 'notifications/PUSH_NOTIFICATION'
export const REMOVE_LAST_FROM_QUEUE = 'notifications/REMOVE_LAST_FROM_QUEUE'

export const pushNotification = <T>(payload: {
  notification: InteractiveNotification<T>
  key: string
}) => action(PUSH_NOTIFICATION, payload)

export const removeLastFromQueue = (key: string) => action(REMOVE_LAST_FROM_QUEUE, key)
